"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconCart = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconCart = function IconCart(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("ellipse", {
    cx: 10.401,
    cy: 19.588,
    rx: 2.211,
    ry: 2.255
  }), /*#__PURE__*/_react["default"].createElement("ellipse", {
    cx: 16.591,
    cy: 19.588,
    rx: 2.211,
    ry: 2.255
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.065 7.605c-.389-.483-.972-.773-1.556-.773H8.419l-.583-3.286A1.985 1.985 0 005.891 2H3.945C2.875 2 2 2.87 2 3.933c0 1.063.875 1.932 1.945 1.932h.292l1.654 8.118c.194.966.973 1.546 1.945 1.546h9.727c.876 0 1.557-.58 1.849-1.353l1.945-4.832c.195-.58.097-1.16-.292-1.74z"
  }));
};
exports.IconCart = IconCart;